import {AxiosResponse} from "axios";
import moment from "moment/moment";

export const doesWeekCrossYear = (date: Date): boolean => {
    const selectedMoment = moment(date);

    // Start and end of the week for the selected date
    const startOfWeek = selectedMoment.clone().startOf("isoWeek"); // Monday
    const endOfWeek = selectedMoment.clone().endOf("isoWeek"); // Sunday

    // Check if the week starts in the current year and ends in the next year
    return (
        startOfWeek.year() === selectedMoment.year() &&
        endOfWeek.year() > selectedMoment.year()
    );
}

export const formatNumber = (value: number | undefined | null) => {
    if (value === undefined || value === null)
        return NaN;

    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
    });

    const result = formatter.format(+value).replace(",", " ");
    return result;
}

export const formatNumberBgStandard = (value: number | undefined | null, minimumFractionDigits?: number, maximumFractionDigits?: number) => {
    if (value === undefined || value === null)
        return NaN;

    const formatter = new Intl.NumberFormat('bg-BG', {
        minimumFractionDigits: minimumFractionDigits !== undefined ? minimumFractionDigits : 2,
        maximumFractionDigits: maximumFractionDigits !== undefined ? maximumFractionDigits : 4,
        useGrouping: true
    });

    return formatter.format(value);
}


export const formatNumberWithComma = (value: number | undefined | null) => {
    if (value === undefined || value === null)
        return NaN;

    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
    });

    const result = formatter.format(+value.toFixed(2));
    return result;
}

export const yesNoOptionsSbyte = (f: any) => {
    return [
        {key: 1, id: 1, description: f({id: "yes"})},
        {key: 0, id: 0, description: f({id: "no"})}
    ]
}

export type Nullable<T> = { [K in keyof T]: T[K] | null };

export const paidOptions = (f: any) => {
    return [
        {key: 1, id: -1, description: f({id: "paid"})},
        {key: 2, id: 0, description: f({id: "notPaid"})}
    ]
}

export const getFileNameFromContentDisposition = (response: AxiosResponse) => {
    const token = response.headers['content-disposition'].split('filename=')[1];
    const utfDelimiter = "UTF-8''";

    const filename = token.substring(token.indexOf(utfDelimiter) + utfDelimiter.length);
    const decodedFileName = decodeURI(filename);
    return decodedFileName;
}

export const parseDataTableFilters = (filters: any) => {
    const parsedFilters = Object.keys(filters).reduce((acc: any, key: string) => {
        //Handle multiselect with empty array.
        if (Array.isArray(filters[key].value) && filters[key].value.length === 0) return acc;

        //Handle dates
        if (filters[key].value && filters[key].value instanceof Date) {
            return {...acc, [key]: moment(filters[key].value).toISOString(true)}
        }

        // Handle range date selection -> [Date, Date]
        if (Array.isArray(filters[key].value) && filters[key].value.length == 2 && filters[key].value[0] && filters[key].value[0] instanceof Date) {
            return {
                ...acc, [key]: String(filters[key].value.map((el: any) => {
                    if (el instanceof Date)
                        return moment(el).toISOString(true)
                    return ""
                }))
            }
        }

        if (filters[key].value !== null && filters[key].value !== '' && filters[key].value !== undefined)
            return {...acc, [key]: String(filters[key].value)}
        return acc
    }, {});

    return parsedFilters;
}

export const translateNumberToMonth = (monthNumber: number, startFromZero: boolean, formatter: any): string | undefined => {
    const monthsMap = {
        1: formatter({id: 'january'}),
        2: formatter({id: 'february'}),
        3: formatter({id: 'march'}),
        4: formatter({id: 'april'}),
        5: formatter({id: 'may'}),
        6: formatter({id: 'june'}),
        7: formatter({id: 'july'}),
        8: formatter({id: 'august'}),
        9: formatter({id: 'september'}),
        10: formatter({id: 'october'}),
        11: formatter({id: 'november'}),
        12: formatter({id: 'december'})
    };

    if (startFromZero){
        if ((monthNumber + 1) in monthsMap){
            const key = monthNumber + 1 as keyof typeof monthsMap;
            return monthsMap[key];
        }
    }else{
        if (monthNumber in monthsMap){
            const key = monthNumber as keyof typeof monthsMap;
            return monthsMap[key];
        }
    }

    return undefined;
}
